'use client'

import { useActionState } from 'react'
import Link from 'next/link'

import { Button } from '@/core/components/form/button/button'
import { usePreservedSubmit } from '@/core/hooks/use-preserved-submit'
import { InputText } from '@/core/components/form/input-text'
import { Textarea } from '@/core/components/form/textarea'

import { submitInquiry, type InquiryState } from '../actions/inquiry'

import type { Route } from 'next'

const INITIAL_STATE: InquiryState = { status: 'idle' }

export default function InquiryForm() {
  const [state, action, pending] = useActionState(submitInquiry, INITIAL_STATE)
  const onSubmit = usePreservedSubmit(action)
  const errors = state.fieldErrors ?? {}

  if (state.status === 'success') {
    return (
      <div role="status" className="border-b border-border pb-8">
        <p className="type-title">{state.message}</p>
        <Link
          href="/products"
          className="type-ui mt-4 inline-block font-medium underline"
        >
          상품 계속 보기
        </Link>
      </div>
    )
  }

  return (
    <form action={action} onSubmit={onSubmit} className="flex flex-col gap-5">
      <div className="grid gap-4 over6:grid-cols-2">
        <InputText
          label="이름"
          name="name"
          autoComplete="name"
          required
          error={errors.name}
        />
        <InputText
          label="연락처(휴대폰 또는 이메일)"
          name="contact"
          required
          error={errors.contact}
        />
      </div>
      <InputText
        label="차종·연식"
        name="vehicle"
        placeholder="예: 기아 EV3 2025년식"
      />
      <Textarea
        label="문의 내용"
        name="message"
        rows={7}
        required
        error={errors.message}
      />
      {state.status === 'error' && state.message && (
        <p role="alert" className="text-c13 text-error">
          {state.message}
        </p>
      )}
      <div className="flex flex-col gap-3 over8:flex-row over8:items-center over8:justify-between over8:gap-6">
        <p className="type-meta text-description">
          답변을 위해 이름과 연락처를 수집합니다. 자세한 내용은{' '}
          <Link href={'/policy/privacy' as Route} className="underline">
            개인정보처리방침
          </Link>
          을 확인해 주세요.
        </p>
        <Button type="submit" size="lg" loading={pending} className="shrink-0">
          문의 남기기
        </Button>
      </div>
    </form>
  )
}
